import { baseFontSize } from './baseFontSize'

export const calcRem = (...vals: number[]) =>
    vals.map((val) => (val !== 0 ? `${val / baseFontSize}rem` : '0')).join(' ')

export default calcRem
